<template>
	<tr>
		<td class="min">{{ place }}.</td>
		<td class="nickname">{{ user.nickname }}</td>
		<td>${{ dollars }}</td>
		<td class="min"><slot /></td>
	</tr>
</template>

<script>
import { toDollars } from 'recycle-race-common/lib/functions'

export default {
	name: 'LeaderboardRow',
	props: {
		user: Object,
		score: Number,
		place: Number,
	},
	computed: {
		dollars() {
			return toDollars(this.score)
		},
	},
}
</script>

<style scoped>
.nickname {
	hyphens: auto;
}
</style>
